import whenDomReady from 'when-dom-ready';
const ACTIVE = 'is-active';
function initialise() {
    const classifications = Array.from(document.querySelectorAll('.js-classification-button'));
    if (classifications.length > 0) {
        bindTables(classifications);
    }
}
function bindTables(classifications) {
    for (let i = 0; i < classifications.length; i += 1) {
        const classification = classifications[i];
        const classificationTable = document.querySelectorAll('.js-classification-table')[i];
        const classificationLevel = document.querySelectorAll('.js-classification-level')[i];
        if (classificationTable && classificationLevel) {
            classification.addEventListener('click', () => {
                handleClick(classification, classificationTable, classificationLevel);
            });
        }
    }
}
function handleClick(classification, classificationTable, classificationLevel) {
    let active = document.querySelector('.js-classification-button.is-active');
    let activeContent = document.querySelector('.js-classification-table.is-active');
    const activeLevel = document.querySelector('.js-classification-level.is-active');
    const overviewTable = document.querySelector('.js-classification-table-overview');
    const classificationLines = document.querySelector('.js-classification-lines');
    if (!classificationTable.classList.contains(ACTIVE)) {
        classificationTable.classList.add(ACTIVE);
    }
    if (activeContent) {
        activeContent.classList.remove(ACTIVE);
    }
    if (!classificationLevel.classList.contains(ACTIVE)) {
        classificationLevel.classList.add(ACTIVE);
    }
    if (activeLevel) {
        activeLevel.classList.remove(ACTIVE);
    }
    if (!classification.classList.contains(ACTIVE)) {
        classification.classList.add(ACTIVE);
    }
    if (active) {
        active.classList.remove(ACTIVE);
    }
    //check if any tables are active so we know whether to show the overview table or not
    active = document.querySelector('.js-classification-button.is-active');
    activeContent = document.querySelector('.js-classification-table.is-active');
    if (active === null && activeContent === null) {
        overviewTable?.classList.add(ACTIVE);
        classificationLines?.classList.add(ACTIVE);
    }
    else {
        overviewTable?.classList.remove(ACTIVE);
        classificationLines?.classList.remove(ACTIVE);
    }
}
whenDomReady().then(initialise);
